export const DOMAINS_MODAL_HASH = "#setup-domain";
export const FORWARDING_INSTRUCTIONS_HASH = "#forwarding";
export const FORWARDING_SETUP_HASH = "#edit-";

export enum EmailSettingsRoutes {
  BaseRoute = "/settings/email-addresses",
  ForwardingAddresses = "/settings/email-addresses/forwarding",
  ForwardingAddressesWithInstructions = `/settings/email-addresses/forwarding/${FORWARDING_INSTRUCTIONS_HASH}`,
  ForwardingAddressesWithSetupModal = `/settings/email-addresses/forwarding/${FORWARDING_SETUP_HASH}`,
  ForwardingAddressesWithSetupDefault = `/settings/email-addresses/forwarding/${FORWARDING_SETUP_HASH}default`,
  ReplyAddresses = "/settings/email-addresses/reply",
  Domains = "/settings/email-addresses/domains",
  DomainsWithModal = `/settings/email-addresses/domains/${DOMAINS_MODAL_HASH}`,
}

export enum EmailSettingsSubsection {
  ForwardingAddresses = "forwarding",
  ReplyAddresses = "reply",
  Domains = "domains",
}
